import { createFileRoute } from '@tanstack/react-router';
import { BrandMentionCheckerPage } from '../../../pages/tools/research-tools/BrandMentionCheckerPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/brand-mention-checker')({
  head: () => toolHead('brand-mention-checker'),
  component: BrandMentionCheckerPage,
});
